import { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";

export function useSocket() {
  const socketRef = useRef(null);
  const [connected, setConnected] = useState(false);

  // Определяем URL сервера на основе текущего домена.
  // В локальной разработке (CRA на :3000) бэкенд слушает на :6482, поэтому
  // подставляем порт явно. В остальных окружениях (в т.ч. за nginx по HTTPS)
  // используем origin как есть — без принудительного :6482, иначе wss-хендшейк
  // уходит на несуществующий порт (https://домен:6482) и веб-сокеты падают.
  const resolveSocketUrl = () => {
    try {
      const currentUrl = new URL(window.location.origin);
      if (currentUrl.hostname === "localhost" && currentUrl.port === "3000") {
        return "http://localhost:6482";
      }
    } catch (error) {
      // Фолбэк ниже сохраняет поведение, если разбор URL не удался.
    }
    return window.location.origin;
  };

  const url = resolveSocketUrl();

  const connect = () => {
    if (socketRef.current) {
      socketRef.current.disconnect();
    }

    socketRef.current = io(url, {
      withCredentials: true,
      autoConnect: true,
      transports: ["websocket", "polling"],
    });

    const socket = socketRef.current;

    socket.on("connect", () => setConnected(true));
    socket.on("disconnect", () => setConnected(false));
  };

  useEffect(() => {
    connect();

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
    };
    // eslint-disable-next-line
  }, [url]);

  const reconnect = () => {
    connect();
  };

  return { socket: socketRef.current, connected, reconnect };
}
